import { state } from '@/manager/client/store/state';
import { getters } from '@/manager/client/store/getters';
import { mutations } from '@/manager/client/store/mutations';
import { actions } from '@/manager/client/store/action';

export const client = {
    state,
    getters,
    actions,
    mutations,
};
